module.exports = __webpack_public_path__ + "static/media/profile2025.2601ccc6.jpg";